import React from "react";
import { createContext, useState, useContext, useEffect } from "react";
import { CreateChatService } from "../../services/Chat/ChatService";
import { AuthContext } from "../../contexts/AuthContext/AuthContext";
import { ConversationContext } from "../../contexts/ChatContext/ConversationContext"
import { InformationBasicContext } from "../../contexts/InformationBasicContext/InformationBasicContext"
import { ThreadContext } from "../../contexts/Thread/ThreadContext"

export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [answer, setAnswer] = useState(null);
  const [thread_id, setThread_id] = useState(() => localStorage.getItem("thread_id"));
    
  const { token } = useContext(AuthContext);
  const { setConversation } = useContext(ConversationContext);
  const { companySelected } = useContext(InformationBasicContext);
  const { GetHistoryThreads } = useContext(ThreadContext);

  useEffect(() => {
    const storedThread_id = localStorage.getItem("thread_id");
    if (storedThread_id) {
      setThread_id(storedThread_id);
    }
  }, []);

  const CreateChat = async (question) => {
    const dataChat = await CreateChatService(question, token, thread_id, companySelected);
    
    if (!dataChat["error"] && "answer" in dataChat["content"]) {
      setAnswer(dataChat["content"]["answer"]);
      setThread_id(dataChat["content"]["thread_id"]);
      setConversation(prev => [
        ...prev, 
        { 
          question: null, 
          answer: dataChat["content"]["answer"],  
          formatted_date: new Date().toLocaleTimeString("es-ES", {
            hour: "2-digit",
            minute: "2-digit"
          })
        }
      ]);
      
      localStorage.setItem("thread_id", dataChat["content"]["thread_id"])

      GetHistoryThreads(companySelected)

      return true;
    }

    return false;
  };

  return (
    <ChatContext.Provider value={{ answer, CreateChat, thread_id, setThread_id }}>
      {children}
    </ChatContext.Provider>
  );
};
